import { Security } from './security';

export class SecurityType {
  securityTypeId!: number;
  name!: string;
  description!: string;
  isActive!: boolean;
  created!: Date;
  createdBy!: string;
  modified!: Date;
  modifiedBy!: string;
  securities!: Security[];
}
